define(
    'viewmodels/secured/explorer/navigation/libraries/library',[
        "viewmodels/secured/explorer/context",
        "services/config",
        "services/eventbroker",                
        "providers/dataprovider",
        "viewmodels/secured/explorer/navigation/libraries/List",
        "viewmodels/secured/explorer/navigation/libraries/FolderActions"
    ],
    function (ctx, config, eventBroker, dataProvider, List, FolderActions) {
        var _allowedActions = [];

        function Library(libraryId, name, listId, listName, i19n, accessControlFolder, accessControlList, _folderSelected, isAdmin) {
            var self = this;

            self._loadTreePromise = null;

            self.libraryId = libraryId,
            self.name = name;
            self.initialized = ko.observable(false);
            self.isBusy = ko.computed(function () {
                return self.menuItem && self.menuItem.isBusy();
            });
            self.list = listId ? new List(listId, listName, self, i19n, accessControlList, isAdmin) : null;
            self.hasList = ko.observable(!!self.list);
            self.urlHash = ko.observable();
            self.folders = ko.observableArray();
            self.loadingFolders = ko.observable(false);
            self.folderActions = new FolderActions(ctx, accessControlFolder); //treenode supplied by widget treeview
            self.folderActions.isTemplate = false;
            self.treeData = {
                id: 'explorer-treeview-' + libraryId,
                node: {
                    add: {},
                    rename: {},
                    remove: {},
                    select: function (n) {
                        var folder = n.data;
                        
                        if (folder) {
                            _cacheAllowedActions(folder.folderId)
                            .done(function (permissions) {
                                self.folderActions.folderId = folder.folderId;
                                self.folderActions.permissions(permissions);
                                
                                _folderSelected(folder);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    }                    
                },
                isShowAllVisible: true,
                deselect: {},
                folderActions: self.folderActions,
                collapseExpand: {},
                loadBegin: {},
                getTreeviewDataSource: function (complete) {
                    return new kendo.data.HierarchicalDataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success([]);
                                
                                if (self._loadTreePromise) {
                                    var folders = [];

                                    if (self.hasList && self.list != null)
                                        folders = mapFolders(self.list.folders());
                                    else if (self.folders != null)
                                        folders = mapFolders(self.folders());

                                    callbacks.success(folders);

                                    complete();

                                    self.initialized(true);
                                    self.loadingFolders(false);

                                    self._loadTreePromise.resolve();
                                }
                            }
                        },
                        schema: {
                            model: {
                                id: "id",
                                hasChildren: "hasChildren",
                                children: "items"
                            }
                        },
                    });
                }
            };            
            
            self.infoText = ko.observable("");
            self.isBeingRenamed = ko.observable(false);
            self.label = ko.observable(name);
            
            self.folderTemplate = null;
            self.isShowFolderTemplate = ko.observable(false);
            self.refreshFolderActions = function () {
                var folder = ctx.current.folder;

                if (folder) {
                    _cacheAllowedActions(folder.folderId, true)
                    .done(function (permissions) {
                        self.folderActions.folderId = folder.folderId;
                        self.folderActions.permissions(permissions);

                        _folderSelected(folder, "folderaction");
                    })
                    .fail(function (e) {
                        console.error(e);
                    });
                }
            };
        }
        
        Library.prototype.loadTree = function () {
            this._loadTreePromise = $.Deferred();
                        
            this.loadingFolders(true);

            if (jQuery.isFunction(this.treeData.loadBegin)) {
                this.treeData.loadBegin();
            } else {
                console.warn('');
            }
            if (jQuery.isFunction(this.treeData.getDataSource)) {
                this.treeData.getDataSource().read();
            } else {
                console.warn('');
            }

            return this._loadTreePromise.promise();
        };

        return Library;

        function _cacheAllowedActions(folderId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;

            var f = _.find(_allowedActions, function (itm) { return !itm ? false : itm.key == folderId; });
            if (refresh)
                _allowedActions = _.without(_allowedActions, f);

            if (f && !refresh) {
                d.resolve(f.value);
            } else {
                dataProvider.accessControl.folders
                .getAllowedActions(folderId)
                .done(function (results) {
                    _allowedActions.push({ key: folderId, value: results });

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });
            }

            return d.promise();
        }

        //mapping also in explorer FolderActions.js
        function mapFolders(folders, expanded) {
            folders = _.map(folders, function (itm) {
                if(!ko.isObservable(itm.name))
                    itm.name = ko.observable(itm.name);

                if (!ko.isObservable(itm.isFavourite))
                    itm.isFavourite = ko.observable(itm.isFavourite);

                return itm;
            });
            //folders = _.sortBy(folders, function (itm) { return itm.name(); });
            folders.sort(function (a, b) {
                if (!a.name() || !b.name())
                    return -1;
                var an = padNumbers(a.name().toLowerCase()),
                    bn = padNumbers(b.name().toLowerCase());
                
                return an > bn ? 1 : -1;
            });

            return _.map(folders, function (itm) {
                var hasChildren = itm.folders ? (itm.folders.length > 0 ? true : false) : false;

                return {
                    id: itm.folderId,                    
                    parentId: itm.parentId,
                    text: itm.name(),
                    expanded: expanded === undefined,
                    hasChildren: hasChildren,
                    docCount: itm.docCount,                    
                    items: itm.folders ? mapFolders(itm.folders, false) : [],
                    data: itm
                };
            });
        }
        function padNumbers(string, length) {
            if (!length) {
                length = 10;
            }

            return string.replace(/(\d+(\S\d+)*)/g, function (m) {
                var delimiter, decimalLength;
                
                //// preserve decimal delimiter
                //m = m.replace(/(\D)(\d+)$/, function (m, delim, num) {
                //    delimiter = delim;
                //    decimalLength = num.length;

                //    return '###' + num;
                //});
                //for (var i = 0; i < 10; i++) {
                    m = m.replace(".", "###");
                //}

                // if decimal delimiter occurs multiple times
                // it is not a decimal delimiter, but thousand delimiter
                if (delimiter && m.indexOf(delimiter) > -1) {                    
                    m = m.replace('###', '');
                } else {
                    
                    // TODO: what to do with decimals that 
                    // are 3-accurate - could be german thousand-delimiter
                }

                // remove thousand delimiters
                m = m.replace(/[^0-9#]/g, '');

                // left-padd integer
                m = m.replace(/^\d+/, function (m) {
                    while (m.length < length) {
                        m = "0" + m;
                    }

                    return m;
                });

                // add decimal component
                if (m.indexOf('#') < 0) {
                    m += "###0";
                }

                // right-padd decimal
                m = m.replace(/#(\d+)$/, function (tmp, m) {
                    while (m.length < length) {
                        m += "0";
                    }

                    return m;
                });

                return m;
            });
        }
        //function findFolder(folders, folderId) {
        //    var found = _.find(folders, function (folder) {
        //        return folder.folderId == folderId;
        //    });

        //    if (!found) {
        //        for (var i = 0; i < folders.length; i++) {
        //            var folder = folders[i];
        //            if (folder.folders) {
        //                found = findFolder(folder.folders, folderId);
        //                if (found)
        //                    break;
        //            }
        //        }
        //    }

        //    return found;
        //}        
    });
